import { initRender } from "./render";
import { run } from "./runner";

run()
initRender()